const { logError } = require('../logger');
const BattleCalc = require('../BattleCalc');

const DeathEvent = function (battleState) {
  this.eventHandle = 'death';

  this.execute = (victim) => {
    if (!victim) {
      return;
    }

    if (victim.dead || !victim.inPlay) {
      return;
    }

    try {
      // expire any AngelMask inspired conditions
      for (const ally of BattleCalc.getAlliesOfUnit(
        victim,
        battleState.allUnits,
        true
      )) {
        for (const c of Object.values(ally.conditions || {})) {
          if (c.handle === 'inspired' && c.instigatorId === victim.uid) {
            battleState.expireCondition(c.uid);
          }
        }
      }

      this.actorId = victim.uid;
      this.victimId = victim.uid;
      victim.hp = 0;
      victim.dead = true;
      victim.inPlay = false;
      var tile = battleState.getTileAtCoords(victim.x, victim.y);
      if (tile) {
        tile.occupied = false;
      }
      this.unit = victim;
      this.victimHandle = victim.handle;

      this.deathTile = tile;

      this.affectedPieces = [victim, tile];
      battleState.onBattleEvent(this);
    } catch (err) {
      logError(err, {
        module: 'DeathEvent',
        func: 'execute',
        victim,
        battleState,
      });
    }
  };
};
module.exports = DeathEvent;
